import { List,IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import './request.scss'
import RequestListItem from "./requestList/requestListItem";
import './request.scss'
import { useAppSelector, useAppDispatch } from "../../../store/hooks/hooks";
import { GetRequests } from "../../../store/StudentAction";



const RequestList = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [filterStatus, setFilterStatus] = useState("")
    const [filterDisplay,setFilterDisplay] = useState("All")
    const requests = useAppSelector((state) => state.user.requests)
    const dispatch = useAppDispatch()
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const fetcRequests = async () => {
        await dispatch(GetRequests())
    }
    useEffect(() => {
        fetcRequests()
    },[])

    const requestTypes = (request: any,index:any) => {
        switch (request.requestCode) {
            case 'LR':
                return <>
                    <RequestListItem key={index} request={request}></RequestListItem>
                </>
            case 'DR':
                return <>
                    <RequestListItem key={index} request={request}></RequestListItem>
                </>
            case 'CP':
                return <>
                    <RequestListItem  key={index} request={request}></RequestListItem>
                </>
            default:
                <>No Requests</>
        }
    }
    const Filter = (status: string) => {
        return requests.filter((elm: any) => {
            return ("" + elm.Status).includes(status)
        })
    }

    return (
        <div className="listOuterContainer ">
            <div className="align-items-center flex justify-content-between pt-3 px-3">
                <h4 className="cardTitle">Requests</h4>
                <div>
                    <div className="flex">
                        <IconButton aria-label="filter" className="filterButton mx-2" onClick={handleClick} size="small">
                            <FilterListRoundedIcon fontSize="small" />
                            <p className="filterText m-0 px-1">{filterDisplay}</p>
                        </IconButton>
                    </div>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={() => {
                            setFilterStatus("")
                            setFilterDisplay("All")
                            handleClose()
                        }}>All</MenuItem>
                        <MenuItem onClick={() => {
                            setFilterStatus("0")
                            setFilterDisplay("Pending")
                            handleClose()
                        }}>Pending</MenuItem>
                        <MenuItem onClick={() => {
                            setFilterStatus("1")
                            setFilterDisplay("Approved")
                            handleClose()
                        }}>Approved</MenuItem>
                        <MenuItem onClick={() => {
                            setFilterStatus("2")
                            setFilterDisplay("Rejected")
                            handleClose()
                        }}>Rejected</MenuItem>
                    </Menu>
                </div>
            </div>
            {
                Filter(filterStatus).length > 0 ? <List sx={{ width: '100%', bgcolor: 'background.paper' }} >
                    {[...Filter(filterStatus).sort((a:any,b:any) => new Date(a.details.dateApplied) > new Date(b.details.dateApplied) ? -1 : 1)].map((value: any, index: any) => {
                        return (
                            <>
                                {requestTypes(value,index)}
                            </>
                        );
                    })}
                </List> : <>
                    <div className="align-items-center flex h-100 justify-content-center w-100">
                        <p className="subTitle gray-color body-p m-0 ">No Requests Found</p>
                    </div>
                </>
            }

        </div>
    )

}
export default RequestList